<template>
   <div :class="['media-card', `media-card-${card.type}`]">
      <template v-if="card.type == 'audio'">
         <div class="background-audio-wave">
            <div class="visual">
               <AudioWave class="wave" />
            </div>
            <h4 class="bold sans">{{ card?.audio?.name ?? card?.name }}</h4>
         </div>
         <div class="audio-card-meta">
            <AudioWrapper :card="card" hideTitle />
            <MediaCardAction
               :card="card"
               :savable="savable"
               :classId="classId"
            />
         </div>
      </template>
      <template v-else-if="card?.type == 'wistia'">
         <div class="visual"><VideoWrapper :card="card" /></div>
         <div class="video-card-meta">
            <h4 class="sans">{{ card?.title }}</h4>

               <MediaCardAction
                  :card="card"
                  :savable="savable"
                  :classId="classId"
               />

         </div>
      </template>
   </div>
</template>

<script setup lang="ts">
import AudioWave from "~/assets/images/audio-wave.svg?component";

// REFS/PROPS ================
const props = defineProps({
   card: { type: Object, required: true },
   savable: { type: Boolean, required: false, default: false },
   classId: { type: Number, required: false },
});
</script>

<style lang="scss">
div.media-card {
   border-radius: pad(0.5);
   div.visual {
      overflow: hidden;
      border-radius: pad(0.5) pad(0.5) 0 0;
   }
   &.media-card-audio {
      border: 1px solid $border-dk;
      div.visual {
         margin-top: 0;
         align-self: center;
      }
      div.background-audio-wave {
         position: relative;
         width: 100%;
         aspect-ratio: 16 / 9;
         background: $white;
         @include flex(row, flex-start, center);
         svg.wave {
            display: block;
            max-height: 100%;
            width: 100%;
            padding: pad(4);
         }
         h4.sans {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: pad(2) pad(2) 0;
         }
      }
      div.audio-card-meta {
         background-color: $beige-lt;
         padding: pad(2);
         display: grid;
         grid-template-columns: 1fr auto;
         column-gap: pad(2);
         div.audio-player {
            border-radius: 0;
            padding: 0;
            background-color: transparent;
            border-color: transparent;
         }
         h4.sans {
            margin: 0;
         }
         div.media-card-action {
            align-self: center;
         }
      }
   }
   &.media-card-wistia {
      border: 1px solid $border-dk;
      div.video-card-meta {
         background-color: $beige-lt;
         padding: pad(2);
         display: grid;
         grid-template-columns: 1fr auto;
         column-gap: pad(1);
         h4.sans {
            margin: 0;
         }
         div.media-card-action {
            align-self: flex-start;
         }
      }
   }
}
</style>
